/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DuplicationType {
  Add = 'ADD',
  Overwrite = 'OVERWRITE',
  Block = 'BLOCK'
}
